// extracted by mini-css-extract-plugin
export default {"Timeline_Item":"TimelineRow-module__Timeline_Item--bJ6Dr","Octicon":"TimelineRow-module__Octicon--Pp07b"};